import React from 'react'
import Layout from '../Layout/Layout'

import { Link } from "react-router-dom";

const Future_of_Food = () => {
  return (
    <Layout>
            <div className='uk-container '>
                  <div className='uk-padding'>
                    <h2 className='light uk-text-bold'>Future of Food</h2>
                   

                  </div>


                  <div className='uk-grid'>
                      <div className='uk-width-1-2'>
                               <p className='light'>Agrifood systems are a leading cause of some of the biggest global challenges,
                         from climate change, resource depletion and waste, to malnutrition, disease and obesity.</p>
                    
                    
                    <p className='light'>Innovative solutions are needed at all stages of the food supply chain.
                    Moolu Venture Lab is creating a Knowledge and Innovation Community dedicated
                     to making our food system more sustainable.</p>

                        <p className='light'>And that can only happen through an inclusive approach where both grower, agrregators and consumer can
                            actively participate in making a better world.
                        Moolu Venture Lab supports and accelerates projects, organizations and individuals that share our
                        goals for a healthy and sustainable food system.</p>
                      </div>

                      <div className='uk-width-1-2'>
                         <h4 className='light uk-text-bold'>How Moolu Venture Lab can partner</h4>
                         <p className='light'>Take your ideas from concept to market so you can launch innovative products, ingredients, and solutions</p>
                         <p className='light'>Engage in a dialogue with the food industry and co-create the future food system through access to our
                             innovative events, digital platforms, and public engagement activities.</p>
                        
                          <p className='light'>Benefit from expert mentoring, tailor-made entrepreneurship programmes, and easy-to-access funding to enable
                             you to launch, accelerate, and scale your agrifood business</p>

                             <p className='light'>Find below link to some of our research work in related to Agrifood and Food security.</p>
                            <Link to ="/Improving_Crop_Productivity"> Find below link to some of our research work in related to Agrifood and Food security.</Link>
                      </div>
                  </div>
            </div>
    </Layout>
  )
}

export default Future_of_Food